import { useState, useEffect, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    AdminUser
  } from '../../utils'
import ThemeOption from '../../components/ThemeOption'
import { Client, Account } from "appwrite";
import DashboardMenu from '../../components/DashboardMenu'
import FileUpload from '../../components/FileUpload'
import RunFunction from '../../components/RunFunction'
import { storage } from '../../appwrite/config'

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import RadioSelect from '../../components/RadioSelect'
import LogoLoader from '../../components/LogoLoader';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);


export default function WallHeightCalculator() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingScreen, setShowLoadingScreen] = useState(false);
    
    // Set authenticated session on initial page load
    useEffect(() => {
        const checkSession = async () => {
            try {
                const user = await account.get()
                return user
            } catch (error) {
                navigate('/')
            }
        }
        setUserSession(checkSession())
    }, []);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowLoadingScreen(true);
        }, 50);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 0);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    if (isLoading && showLoadingScreen) return <LogoLoader />;

    return (<>
        {userSession && <DashboardMenu path="" user={userSession} page={<div className="page-content">
            <Typography variant="h4" gutterBottom>Wall Height Calculator</Typography>
            
            <FileUpload multiple type="pdf" />

            <RadioSelect
                header="Project type"
                options={["Single-Family", "Multi-Family / Commercial"]}
                defaultIndex={0}
                row={true}
                docKey="projectType"
                widgetName="wall-height-calculator"
                tooltip="This adjusts the wall height rounding in the output spreadsheet."
            />

            {/* <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id="advanced-settings-header"
                >
                    <Typography component="span">Advanced Settings <i>(optional)</i></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    Advanced settings go here...
                </AccordionDetails>
            </Accordion> */}

            <br/>
            <RunFunction name="wall-height-calculator" button="Process PDF" />
        </div>} />}
    </>)
}